module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-right-f030f9db04711643a8b421bb60f13018.svg";